import React, { useState } from 'react';
import { createCn } from '../../../helpers/utils';
import classes from '../styles.module.scss';
import { langLabel } from '../utils/speaker-language';

const cn = createCn('file', classes);

export type TeamsSpeakerInfo = {
  name: string;
  utterances: number;
  chars: number;
  language_suggested: string;
  sample?: string;
};

export type TeamsImportResult = {
  teams_speakers: TeamsSpeakerInfo[];
  mapping: Record<string, string>;
  speaker_languages: Record<string, string>;
  meeting_speakers: string[];
};

type Props = {
  onImport: (transcript: string) => Promise<TeamsImportResult>;
  importing?: boolean;
};

const TeamsImportPanel = ({ onImport, importing = false }: Props) => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');
  const [result, setResult] = useState<TeamsImportResult | null>(null);

  const handleImport = async () => {
    if (!text.trim()) return;
    const res = await onImport(text);
    setResult(res);
  };

  return (
    <div className={cn('teams-import-panel')}>
      <button
        type="button"
        className={cn('teams-import-toggle')}
        onClick={() => setOpen(v => !v)}
      >
        {open ? '▾' : '▸'} Импорт из Microsoft Teams
      </button>
      {open && (
        <div className={cn('teams-import-body')}>
          <p className={cn('teams-import-hint')}>
            Вставьте транскрипт Copilot из Teams (формат «Имя (ТТК)   0:22»).
            Система сопоставит SPEAKER_00/01 с именами и предложит языки: для казахской речи
            в Teams часто показывается «ломаный» русский — такие спикеры помечаются как kz.
          </p>
          <textarea
            className={cn('teams-import-textarea')}
            rows={8}
            placeholder={'Галихан Мухамед-Рахимов (ТТК)   0:22\nНу всё, давайте начинать.'}
            value={text}
            onChange={e => setText(e.target.value)}
          />
          <div className={cn('teams-import-actions')}>
            <button
              type="button"
              className={cn('download-btn')}
              disabled={importing || !text.trim()}
              onClick={handleImport}
            >
              {importing ? 'Импорт…' : 'Импортировать и применить'}
            </button>
          </div>
          {result && (
            <div className={cn('teams-import-result')}>
              <h4 className={cn('teams-import-result-title')}>Спикеры Teams</h4>
              <ul className={cn('teams-import-list')}>
                {result.teams_speakers.map(sp => (
                  <li key={sp.name} className={cn('teams-import-item')}>
                    <span className={cn('teams-import-name')}>{sp.name}</span>
                    <span className={cn('teams-import-meta')}>
                      {sp.utterances} репл. · {langLabel(sp.language_suggested)}
                    </span>
                  </li>
                ))}
              </ul>
              {Object.keys(result.mapping).length > 0 && (
                <>
                  <h4 className={cn('teams-import-result-title')}>Сопоставление с диаризацией</h4>
                  <ul className={cn('teams-import-list')}>
                    {Object.entries(result.mapping).map(([label, name]) => (
                      <li key={label} className={cn('teams-import-item')}>
                        <code>{label}</code>
                        <span>→</span>
                        <span>{name}</span>
                        {result.speaker_languages[label] && (
                          <span className={cn('speaker-lang-badge')}>
                            {langLabel(result.speaker_languages[label])}
                          </span>
                        )}
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TeamsImportPanel;
